import { render, staticRenderFns } from "./PayHistory.vue?vue&type=template&id=2edf8d53&scoped=true&"
import script from "./PayHistory.vue?vue&type=script&lang=js&"
export * from "./PayHistory.vue?vue&type=script&lang=js&"
import style0 from "./PayHistory.vue?vue&type=style&index=0&id=2edf8d53&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edf8d53",
  null
  
)

export default component.exports